<template>
  <Layout>
    <div class="industryPage">
      <Header :data="$props" />
      <div class="backimg">
        <div class="backimgBox">
          <StaticBanner :banner-date="bannerDate"></StaticBanner>
        </div>
      </div>
      <dropdownMenu :pkname="'行业解决方案'" @func="chagnerouter" :type="type" :pktype="'industry'"></dropdownMenu>
      <div class="titles" :class="{'d-none': windowWidth<767}">
        <div class="in_titles">
          <div class="in_titles_left">
            <img class="in_titles_left_img" src="@/assets/images/industry/tb.png" alt="">
            <div><span style="margin-right: 10px;">&gt;</span><span style="font-size: 18px;">行业解决方案</span></div>
          </div>
          <div class="in_titles_right">
            <div :class="type == '1' ? 'changes' : ''" @click="chagnerouter(1)">制造行业</div>
            <div :class="type == '2' ? 'changes' : ''" @click="chagnerouter(2)">建筑与地产行业</div>
            <div :class="type == '3' ? 'changes' : ''" @click="chagnerouter(3)">服务行业</div>
            <div :class="type == '4' ? 'changes' : ''" @click="chagnerouter(4)">公共服务行业</div>
            <div :class="type == '5' ? 'changes' : ''" @click="chagnerouter(5)">能源与矿业行业</div>
            <div :class="type == '6' ? 'changes' : ''" @click="chagnerouter(6)">金融行业</div>
          </div>
        </div>
      </div>
      <div class="title container">
        <div class="tab-block pt-lyd-120 title_box container" data-aos="fade-up" v-for="(item,index) in titlesData[type - 1]">
          <div class="fs-1 fw-bold text-center lyd-title-colo1" data-aos="fade-up">{{item.title}}</div>
          <img src="@/assets/images/industry/diagram.png" alt="" data-aos="fade-up">
        </div>
      </div>
      <div class="titlecontents">
        <div class="bg-block">
          <div class="bg"></div>
        </div>
        <div class="tab-block pt-lyd-120 container ind ">
          <div class="fs-1 fw-bold tab-block_titles text-center lyd-title-colo1 text-white" data-aos="fade-up">行业应用重点</div>
          <p class="fs-3 text-center tab-block_titles lyd-title-colo1 text-white">最有深度的新业财融合数字化专家</p>
        </div>
        <div class="titlecontent container" v-if="windowWidth > 767 && titleData.length <= 3" data-aos="fade-left">
          <div class="trades" v-for='(item, index) in titleData' :key='index'>
            <div class="contentBox" :id="index" @mouseover="titleChange(index)">
              <img class="contentTitleimg1" src="@/assets/images/industry/bgcontent2.png">
              <img class="contentTitleimg" src="@/assets/images/industry/bgcontent1.png">
              <div class="contentTitleBox">
                <img class="contentimg1" :src="item.img1" alt="">
                <img class="contentimg" :src="item.img2" alt="">
                <h5 class="contentH5 text-white">{{ item.title }}</h5>
                <div class="contentTitle">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="titlecontent container" v-else-if="windowWidth > 767 && titleData.length > 3">
          <div class="titleSwiper">
            <swiper class="mySwipe" :options="SwipersOptiones" ref="titleSwipers">
              <swiper-slide v-for="(item, index) in titleData" :key='index'>
                <div class="contentBox" :id="index" @mouseover="titleChange(index)">
                  <img class="contentTitleimg1" src="@/assets/images/industry/bgcontent2.png">
                  <img class="contentTitleimg" src="@/assets/images/industry/bgcontent1.png">
                  <div class="contentTitleBox">
                    <img class="contentimg1" :src="item.img1" alt="">
                    <img class="contentimg" :src="item.img2" alt="">
                    <h5 class="contentH5">{{ item.title }}</h5>
                    <div class="contentTitle">{{ item.content }}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div>
        <div class="titlecontent container" v-else>
          <div class="titleSwiper">
            <swiper class="mySwipe mgb1" :options="swiperesOptionr" v-if="titleData.length" ref="titleSwipers">
              <swiper-slide v-for="(item, index) in titleData" :key='index'>
                <div class="contentBox" :id="index" @mouseover="titleChange(index)">
                  <img class="contentTitleimg1" src="@/assets/images/industry/bgcontent2.png">
                  <img class="contentTitleimg" src="@/assets/images/industry/bgcontent1.png">
                  <div class="contentTitleBox">
                    <img class="contentimg1" :src="item.img1" alt="">
                    <img class="contentimg" :src="item.img2" alt="">
                    <h5 class="fs-1 contentH5">{{ item.title }}</h5>
                    <div class="fs-text contentTitle">{{ item.content }}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination9" slot="pagination"></div>
          </div>
        </div>
      </div>
      <div class="highlights">
        <div class="tab-block pt-lyd-120 container ind">
          <div class="fs-1 fw-bold text-center lyd-title-colo1" data-aos="fade-up">方案亮点</div>
          <div class="fs-3 text-center lyd-title-colo1" data-aos="fade-up">最有深度的新业财融合数字化专家</div>
        </div>
        <div class="highSwiper container" v-if="windowWidth > 767 && heighlightData.length > 4">
          <div class="highSwiperBox">
            <swiper class="mySwipe" :options="swiperOption" ref="videoSwiper">
              <swiper-slide v-for="(item, index) in heighlightData" :key='index'>
                <p class="swiperBox">
                  <img :src="item.img" alt="">
                </p>
                <div>{{ item.title }}</div>
              </swiper-slide>
            </swiper>
            <div v-if="heighlightData.length > 4" class="swiper-pagination1" slot="pagination"></div>
          </div>
        </div>
        <div class="higBox container" v-else-if="windowWidth > 767 && heighlightData.length <= 4">
          <div v-for="(item, index) in heighlightData" :key='index'>
            <p class="swiperBox">
              <img :src="item.img" alt="">
            </p>
            <div>{{ item.title }}</div>
          </div>
        </div>
        <div class="highSwiper container" v-else>
          <div class="highSwiperBox">
            <swiper class="mySwipe" :options="swiperOptions" v-if="heighlightData.length" ref="videoSwiper">
              <swiper-slide v-for="(item, index) in heighlightData" :key='index'>
                <p class="swiperBox">
                  <img :src="item.img" alt="">
                </p>
                <div class="fs-text">{{ item.title }}</div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination2" slot="pagination"></div>
          </div>
        </div>
      </div>
      <div class="cores">
        <div class="bg-block">
          <div class="bg"></div>
        </div>
        <div class=" tab-block pt-lyd-120 container">
          <div class='fs-1 fw-bold text-center lyd-title-colo1' data-aos="fade-up">核心应用</div>
          <div class='fs-3 text-center lyd-title-colo1' data-aos="fade-up">最有深度的新业财融合数字化专家</div>
        </div>
        <div class="container core" v-if="windowWidth > 767">
          <div class="coreBoxs">
            <swiper class="mySwipe" :options="swiperOptiones" v-if="coreData.length" ref="videoSwiper">
              <swiper-slide v-for="item in coreData">
                <div class="coreBox">
                  <div class="coreBoxTitle">
                    <img class="coreBoxTitle_img" :src="item.img1" alt="">
                    <p>{{ item.title }}</p>
                  </div>
                </div>
                <div class="coreBox2">
                  <div class="coreBoxTitle">
                    <img class="coreBoxTitles_img" :src="item.img2" alt="">
                    <p class="text-white">{{ item.title }}</p>
                  </div>
                  <div class="coreBoxContent">
                    <p style="font-size: 13px;" class="text-white" v-for="(i, ind) in item.content" :key='ind'>
                      {{ i.title }}</p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination3" slot="pagination"></div>
          </div>
        </div>
        <div class="core container" v-else>
          <div class="coreBoxs">
            <swiper class="mySwipe  mgb1" :options="swipererOptions" v-if="coreData.length" ref="videoSwiper">
              <swiper-slide v-for="item in coreData">
                <div class="coreBox">
                  <div class="coreBoxTitle">
                    <img class="coreBoxTitle_img" :src="item.img1" alt="">
                    <p class="fs-3">{{ item.title }}</p>
                  </div>
                </div>
                <div class="coreBox2">
                  <div class="coreBoxTitle">
                    <img class="coreBoxTitles_img" :src="item.img2" alt="">
                    <p class="text-white fs-1">{{ item.title }}</p>
                  </div>
                  <div class="coreBoxContent">
                    <p class="text-white fs-text" v-for="(i, ind) in item.content" :key='ind'>
                      {{ i.title }}</p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination4" slot="pagination"></div>
          </div>
        </div>
      </div>
      <div class="mores" id="Home-eec">
        <div class="container">
          <div class="Home-eec-tabs-h mt-lyd-20"  data-aos="fade-up">
            <h3 class='fs-4 fw-bold text-center lyd-title-colo1 Home-eec-tabs-tab' :class="{ 'bt-active': isShow }"
              @click="isShow = !isShow">相关产品</h3>
            <h3 class='fs-4 fw-bold text-center lyd-title-colo1 Home-eec-tabs-tab' :class="{ 'bt-active': !isShow }"
              @click="isShow = !isShow">更多行业</h3>
          </div>
        </div>
        <div class="container more" data-aos="fade-up">
          <div class="moreBoxs" v-if="isShow && windowWidth > 767">
            <swiper class="mySwipe" :options="SwiperOptiones" ref="videoSwiper">
              <swiper-slide v-for="(item, index) in moreproductData[type - 1]" :key="index">
                <div class="moreBox">
                  <div class="moreBoxImgs">
                    <img class="moreBoxImg1" :src="item.img" alt="">
                    <img class="moreBoxImg2" src="@/assets/images/industry/bankground.png" alt="">
                  </div>
                  <div class="moreBoxContent">
                    <h5>{{ item.title }}</h5>
                    <button type="button" class="btn btn-outline-primary text-white liaojieallborder" @click="toDetails(item)">查看详情</button>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination5" slot="pagination"></div>
          </div>
          <div class="moreBoxs" v-if="isShow && windowWidth <= 767">
            <swiper class="mySwipe" :options="swipersOptions" ref="videoSwiper">
              <swiper-slide v-for="(item, index) in moreproductData[type - 1]" :key="index">
                <div class="moreBox">
                  <div class="moreBoxImgs">
                    <img class="moreBoxImg1 imgs" :src="item.img" alt="">
                    <img class="moreBoxImg2 imgs" src="@/assets/images/industry/bankground.png" alt="">
                  </div>
                  <div class="moreBoxContent">
                    <h5>{{ item.title }}</h5>
                    <button type="button" class="btn btn-outline-primary text-white liaojieallborder" @click="toDetails(item)">查看详情</button>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination6" slot="pagination"></div>
          </div>
        </div>
        <div class="container morer" data-aos="fade-up">
          <div class="moreBoxes" v-if="!isShow && windowWidth > 767">
            <swiper class="mySwipe" :options="SwiperOptions" ref="videoSwiper">
              <swiper-slide v-for="(item, index) in moreindustryData[type - 1]" :key="index">
                <div class="moreBox">
                  <div class="moreBoxImgs">
                    <img class="moreBoxImg1" :src="item.img" alt="">
                    <img class="moreBoxImg2" src="@/assets/images/industry/bankground.png" alt="">
                  </div>
                  <div class="moreBoxContent">
                    <h5>{{ item.title }}</h5>
                    <button type="button" class="btn btn-outline-primary text-white liaojieallborder">查看详情</button>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination7" slot="pagination"></div>
          </div>
          <div class="moreBoxes" v-if="!isShow && windowWidth <= 767">
            <swiper class="mySwipe" :options="swiperesOptions" ref="videoSwiper">
              <swiper-slide v-for="(item, index) in moreindustryData[type - 1]" :key="index">
                <div class="moreBox">
                  <div class="moreBoxImgs">
                    <img class="moreBoxImg1 imgs" :src="item.img" alt="">
                    <img class="moreBoxImg2 imgs" src="@/assets/images/industry/bankground.png" alt="">
                  </div>
                  <div class="moreBoxContent">
                    <h5>{{ item.title }}</h5>
                    <button type="button" class="btn btn-outline-primary text-white liaojieallborder">查看详情</button>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination8" slot="pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Header from '@/components/common/header/Header'
import Layout from '@/components/common/Layout.vue'
import dropdownMenu from "@/components/common/dropdownMenu.vue"
import StaticBanner from "@/components/common/staticBanner/index.vue"
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'industryPage',
  components: { Header, StaticBanner, swiper, swiperSlide, Layout, dropdownMenu },
  data() {
    return {
      mediaLastIndex: 0,
      swiperOption: {
        speed: 1000,
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination1",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      SwipersOptiones: {
        speed: 1100,
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeTransitionStart: () => {
            this.slideChangeTransitionStartHandle()
          },
        },
        observer: true,
        observeParents: true,
      },
      swiperOptions: {
        speed: 1200,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination2",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swipererOptions: {
        speed: 1300,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination4",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swiperOptiones: {
        speed: 1400,
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination3",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      SwiperOptiones: {
        speed: 1500,
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination5",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      SwiperOptions: {
        speed: 1600,
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination7",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swipersOptions: {
        speed: 1700,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination6",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swiperesOptions:  {
        speed: 1800,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination8",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swiperesOptionr:  {
        speed: 1900,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: false,
        pagination: {
          el: ".swiper-pagination9",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      initOrNot: false, //mediaNews数据改变的时候确保swiper会init一次
      type: '1',
      isShow: true,
      windowWidth: document.documentElement.clientWidth,
      titlesData: [
        [
          {
            'title': '制造行业智慧业财云架构图'
          }
        ],
        [
          {
            'title': '建筑与地产行业智慧业财云架构图'
          }
        ],
        [
          {
            'title': '服务行业智慧业财云架构图'
          }
        ],
        [
          {
            'title': '公共服务行业智慧业财云架构图'
          }
        ],
        [
          {
            'title': '能源与矿业行业智慧业财云架构图'
          }
        ],
        [
          {
            'title': '金融行业智慧业财云架构图'
          }
        ]
      ],
      titleData: [],
      titleDatas: require('@/assets/scss/industy/hangye.json'),
      heighlightData: [],
      heighlightDatas: [
        [
          {
            "img": require("@/assets/images/industry/050601.png"),
            "title": "财务共享服务起点高、内容全、建设快、投资少，业财高度融合、数据高度集成、业务高度共享"
          },
          {
            "img": require("@/assets/images/industry/050602.png"),
            "title": "使业务与财务工作效率以及财务信息质量大幅提升，系统运维成本及人工成本大幅降低，成为财务转型得以真正落地的最佳途径"
          },
          {
            "img": require("@/assets/images/industry/050603.png"),
            "title": "对财务共享的流程、制度等进行不断优化，打造智慧财务，成为行业标杆"
          },
          {
            "img": require("@/assets/images/industry/050604.png"),
            "title": "通过业务财务高度融合，打造服务、管控职能并重的数字化平台"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/374534397.png"),
            "title": "业财一体化全面融合应用"
          },
          {
            "img": require("@/assets/images/industry/361622302.png"),
            "title": "全财务、全业务、全场景的共享服务模式的成功构建"
          },
          {
            "img": require("@/assets/images/industry/354503439.png"),
            "title": "业-财-资-税-票一体化管控体系的搭建"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/143533072.png"),
            "title": "实现了业财融合一体化应用，构建了业-财-资-税-票一体化管控体系"
          },
          {
            "img": require("@/assets/images/industry/421423275.png"),
            "title": "打造了全财务、全业务、全场景的共享服务模式"
          },
          {
            "img": require("@/assets/images/industry/167360244.png"),
            "title": "构建了财务结算中心模式的资金管控管理"
          },
          {
            "img": require("@/assets/images/industry/159382659.png"),
            "title": "将实物发票流统一集中管理，实现三流（合同流、票流、资金流）合一，结合电子发票新技术，通过发票信息集中管控来规避增值税纳税风险"
          },
          {
            "img": require("@/assets/images/industry/050203.png"),
            "title": "打造了服务行业特色全渠道收款的对账平台"
          },
          {
            "img": require("@/assets/images/industry/050403.png"),
            "title": "建立了服务行业特色的单团或全成本核算管理体系"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/050201.png"),
            "title": "财务共享服务起点高、内容全、建设快、投资少，业财高度融合、数据高度集成、业务高度共享"
          },
          {
            "img": require("@/assets/images/industry/050202.png"),
            "title": "使业务与财务工作效率以及财务信息质量大幅提升，系统运维成本及人工成本大幅降低，成为财务转型得以真正落地的最佳途径"
          },
          {
            "img": require("@/assets/images/industry/050203.png"),
            "title": "对财务共享的流程、制度等进行不断优化，打造智慧财务，成为行业标杆"
          },
          {
            "img": require("@/assets/images/industry/050204.png"),
            "title": "通过业务财务高度融合，打造服务、管控职能并重的数字化平台。充分考虑对财务信息统一管理，加强企财务数据的分析洞察，为企业决策提供有力依据"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/050501.png"),
            "title": "四算合一的财务共享体系设计"
          },
          {
            "img": require("@/assets/images/industry/050502.png"),
            "title": "能源与矿业企业特色的认领报账和批量结账应用"
          },
          {
            "img": require("@/assets/images/industry/050503.png"),
            "title": "以项目管理为核心的资金预算和财务关键事项管控"
          },
          {
            "img": require("@/assets/images/industry/050504.png"),
            "title": "规范化合同管理，实现业务财务资金集中管控"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/050401.png"),
            "title": "业财融合一体化应用"
          },
          {
            "img": require("@/assets/images/industry/050402.png"),
            "title": "全财务、全业务、全场景的共享服务模式"
          },
          {
            "img": require("@/assets/images/industry/050403.png"),
            "title": "业-财-资-税-票一体化管控体系"
          },
          {
            "img": require("@/assets/images/industry/050404.png"),
            "title": "金融行业特色的对账平台"
          },
          {
            "img": require("@/assets/images/industry/050503.png"),
            "title": "金融行业特色的全成本核算管理"
          }
        ],
      ],
      coreData: [],
      coreDatas: [
        [
          {
            "img1": require("@/assets/images/industry/0505icon2.png"),
            "img2": require("@/assets/images/industry/0505icon1.png"),
            "title": "合同管理",
            "content": [
              {
                "title": "1.以合同为源头的全生命周期的智能合同管理：包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理。"
              },
              {
                "title": "2.各类合同及电子合同的在线签订。"
              },
              {
                "title": "3.对合同进度、结款等关键节点的预警，具体实施进度的掌握。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0503icon6.png"),
            "img2": require("@/assets/images/industry/3-bai.png"),
            "title": "智能报账",
            "content": [
              {
                "title": "1. 通过部门预算实现费用管控。"
              },
              {
                "title": "2. 通过影像OCR自动识别发票信息关键字管控违反“八项规定”精神的报销事项。"
              },
              {
                "title": "3. 通过预置员工职级，对报销标准进行管控。"
              },
              {
                "title": "4. 影像扫描岗对原始单据合规性以及影像质量进行初审。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0503icon4.png"),
            "img2": require("@/assets/images/industry/0503icon5png.png"),
            "title": "票、税一体化核算管理",
            "content": [
              {
                "title": "1.发票验真查重、自动校对税号；"
              },
              {
                "title": "2.控制发票的实时认证及转出；"
              },
              {
                "title": "3.发票的核销与自助对账。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/1-lanse.png"),
            "img2": require("@/assets/images/industry/tbcore.png"),
            "title": "账务、报表一体化",
            "content": [
              {
                "title": "1.通过财务共享全自动生成凭证，实现智能记账；"
              },
              {
                "title": "2.通过财务共享报账业务及内部交易等的智能化、规范化，达到报表实时化。"
              },
              {
                "title": "3.以合同信息为基础，通过往来客商账龄、资金流动性等分析，加强过程管控。"
              },
              {
                "title": "4.定期发布关键指标、重点事项图表监控，并将抽象数据转换为管理报告，为项目管理提供决策依据。"
              }
            ]
          },
        ],
        [
          {
            "img1": require("@/assets/images/industry/0503icon2.png"),
            "img2": require("@/assets/images/industry/0503icon1.png"),
            "title": "项目管理",
            "content": [
              {
                "title": "1.项目资金预算控制：由单个项目按周做资金预算计划，汇集到各二级考核单位，再由二级单位上报公司审批，从而实现项目资金的总量控制。"
              },
              {
                "title": "2.项目财务关键事项管控：在依据建造成本数据形成的付款申请环节，实现了累计结算金额不能超过合同金额、付款比例不能超过合同约定付款比例、付款金额不能超过发票金额的控制，否则单据不能保存和进入下一审批流程，通过这类系统设置，较好的实现了项目资金管控。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0503icon4.png"),
            "img2": require("@/assets/images/industry/0503icon3.png"),
            "title": "智能报账管理",
            "content": [
              {
                "title": "1.票据标准化审核: 贴标标准化，影像审核取代实物审核, 费用填报与审核的要求和标准统一。"
              },
              {
                "title": "2.业务处理标准更加统一: 统一报销标准，业务源头进行预算事前控制，没有预算一律不予填单。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/1-lanse.png"),
            "img2": require("@/assets/images/industry/tbcore.png"),
            "title": "收付款管控",
            "content": [
              {
                "title": "实现多渠道收款管理模式以及收款对账管理"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0503icon6.png"),
            "img2": require("@/assets/images/industry/0503icon5png.png"),
            "title": "资金管理",
            "content": [
              {
                "title": "1.资金集中管控：建立实体资金池，实现集团资金集中管理，发挥资金池规模效应；同时盘活资金、加强资金的流动性，实现集团整体余缺调剂，降低“存贷三高”并让资金产生效益。"
              },
              {
                "title": "2.资金流动管理：助力集团企业实现现金和票据集中管理资金预算对付款的控制、贴合实际的付款排程，从而加强集团企业资金流动性管理。"
              },
              {
                "title": "3.银企互联共享：实现企业财资管理软件与银行系统的有机联合，整合银企双方资源联机进行银企支付、查询交互日志、查询账户余额及交易明细、进行共享下跨组织业务处理。	"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/tbcore2.png"),
            "img2": require("@/assets/images/industry/2-bai.png"),
            "title": "以项目为主体的票、税一体化管理",
            "content": [
              {
                "title": "1.将企业的实物发票流统一集中管理，实现三流（合同流、票流、资金流）合一，结合电子发票新技术，通过发票信息集中管控来规避营改增纳税风险。"
              },
              {
                "title": "2.统一提供收增值税发票服务，实现统一认证；基于开票和收票数据，实现纳税申报。"
              }
            ]
          }
        ],
        [
          {
            "img1": require("@/assets/images/industry/1-lanse.png"),
            "img2": require("@/assets/images/industry/tbcore.png"),
            "title": "智能报账",
            "content": [
              {
                "title": "1.票据标准化审核: 贴标标准化，影像审核取代实物审核, 费用填报与审核的要求和标准统一。"
              },
              {
                "title": "2.业务处理标准更加统一: 统一报销标准，业务源头进行预算事前控制，没有预算一律不予填单。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/tbcore2.png"),
            "img2": require("@/assets/images/industry/2-bai.png"),
            "title": "资金结算管理",
            "content": [
              {
                "title": "1. 通过银企直联、RPA网银机器人完成资金的统一支付，并通过头寸管理结合资金计划严控资金头寸，保障资金安全。"
              },
              {
                "title": "2. 实现资金的逆向流程线上管理，实现对于错付退回、银行账户有误逆向流程的线上审批，避免出现重付、多付、账务核算错误、账户错误无人监控的情况。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/9010071.png"),
            "img2": require("@/assets/images/industry/3-bai.png"),
            "title": "发票管理",
            "content": [
              {
                "title": "1.与智能报账、影像、税务管理一体化，实现进项发票的归集、自动查验、自动查重、解析、存管、报销入账等全流程过程管理；"
              },
              {
                "title": "2.对增值税发票进行查验，票据自动转存影像文件，用于报销审核及电子档案存储；依据多种业务报账场景，对已采集的发票可进行转让；"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0503icon6.png"),
            "img2": require("@/assets/images/industry/0503icon5png.png"),
            "title": "以合同为主体的票、税一体化管理",
            "content": [
              {
                "title": "1.将企业的实物发票流统一集中管理，实现三流（合同流、票流、资金流）合一，结合电子发票新技术，通过发票信息集中管控来规避增值税纳税风险；"
              },
              {
                "title": "2.统一提供收增值税发票服务，实现统一认证；基于开票和收票数据，实现纳税申报。"
              }
            ]
          }
        ],
        [
          {
            "img1": require("@/assets/images/industry/1-lanse.png"),
            "img2": require("@/assets/images/industry/tbcore.png"),
            "title": "智能报账",
            "content": [
              {
                "title": "1.票据标准化审核: 贴标标准化，影像审核取代实物审核, 费用填报与审核的要求和标准统一。"
              },
              {
                "title": "2.业务处理标准更加统一: 统一报销标准，业务源头进行预算事前控制，没有预算一律不予填单。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/tbcore2.png"),
            "img2": require("@/assets/images/industry/2-bai.png"),
            "title": "资金结算管理",
            "content": [
              {
                "title": "1. 通过银企直联、RPA网银机器人完成资金的统一支付，并通过头寸管理结合资金计划严控资金头寸，保障资金安全。"
              },
              {
                "title": "2. 实现资金的逆向流程线上管理，实现对于错付退回、银行账户有误逆向流程的线上审批，避免出现重付、多付、账务核算错误、账户错误无人监控的情况。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/9010071.png"),
            "img2": require("@/assets/images/industry/3-bai.png"),
            "title": "发票管理",
            "content": [
              {
                "title": "1.与智能报账、影像、税务管理一体化，实现进项发票的归集、自动查验、自动查重、解析、存管、报销入账等全流程过程管理；"
              },
              {
                "title": "2.对增值税发票进行查验，票据自动转存影像文件，用于报销审核及电子档案存储；依据多种业务报账场景，对已采集的发票可进行转让；"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0505icon2.png"),
            "img2": require("@/assets/images/industry/0505icon1.png"),
            "title": "以合同为主体的票、税一体化管理",
            "content": [
              {
                "title": "1.将企业的实物发票流统一集中管理，实现三流（合同流、票流、资金流）合一，结合电子发票新技术，通过发票信息集中管控来规避增值税纳税风险；"
              },
              {
                "title": "2.统一提供收增值税发票服务，实现统一认证；基于开票和收票数据，实现纳税申报。"
              },
              {
                "title": "3.以合同信息为基础，通过往来客商账龄、资金流动性等分析，加强过程管控。"
              },
              {
                "title": "4.定期发布关键指标、重点事项图表监控，并将抽象数据转换为管理报告，为项目管理提供决策依据。"
              }
            ]
          },
        ],
        [
          {
            "img1": require("@/assets/images/industry/0505icon2.png"),
            "img2": require("@/assets/images/industry/0505icon1.png"),
            "title": "合同管理",
            "content": [
              {
                "title": "1.以合同为源头的全生命周期的智能合同管理：包含合同评审、合同签订、合同变更、合同结算、合同发票、合同收付款管理。"
              },
              {
                "title": "2.各类合同及电子合同的在线签订。"
              },
              {
                "title": "3.对合同进度、结款等关键节点的预警，具体实施进度的掌握。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/9010071.png"),
            "img2": require("@/assets/images/industry/3-bai.png"),
            "title": "智能报账",
            "content": [
              {
                "title": "1. 通过部门预算实现费用管控。"
              },
              {
                "title": "2. 通过影像OCR自动识别发票信息关键字管控违反“八项规定”精神的报销事项。"
              },
              {
                "title": "3. 通过预置员工职级，对报销标准进行管控。"
              },
              {
                "title": "4. 影像扫描岗对原始单据合规性以及影像质量进行初审。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/1-lanse.png"),
            "img2": require("@/assets/images/industry/tbcore.png"),
            "title": "票、税一体化核算管理",
            "content": [
              {
                "title": "1.发票验真查重、自动校对税号；"
              },
              {
                "title": "2.控制发票的实时认证及转出；"
              },
              {
                "title": "3.发票的核销与自助对账；"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0505icon4.png"),
            "img2": require("@/assets/images/industry/0505icon3.png"),
            "title": "账务、报表一体化",
            "content": [
              {
                "title": "1.通过财务共享全自动生成凭证，实现智能记账；"
              },
              {
                "title": "2.通过财务共享报账业务及内部交易等的智能化、规范化，达到报表实时化。"
              },
              {
                "title": "3.以合同信息为基础，通过往来客商账龄、资金流动性等分析，加强过程管控。"
              },
              {
                "title": "4.定期发布关键指标、重点事项图表监控，并将抽象数据转换为管理报告，为项目管理提供决策依据。"
              }

            ]
          },
        ],
        [
          {
            "img1": require("@/assets/images/industry/1-lanse.png"),
            "img2": require("@/assets/images/industry/tbcore.png"),
            "title": "智能报账",
            "content": [
              {
                "title": "1.票据标准化审核: 贴标标准化，影像审核取代实物审核, 费用填报与审核的要求和标准统一。"
              },
              {
                "title": "2.业务处理标准更加统一:统一报销标准，业务源头进行预算事前控制，没有预算一律不予填单。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/tbcore2.png"),
            "img2": require("@/assets/images/industry/2-bai.png"),
            "title": "资金结算管理",
            "content": [
              {
                "title": "1. 通过银企直联、RPA网银机器人完成资金的统一支付，并通过头寸管理结合资金计划严控资金头寸，保障资金安全。"
              },
              {
                "title": "2. 实现资金的逆向流程线上管理，实现对于错付退回、银行账户有误逆向流程的线上审批，避免出现重付、多付、账务核算错误、账户错误无人监控的情况。"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/9010071.png"),
            "img2": require("@/assets/images/industry/3-bai.png"),
            "title": "发票管理",
            "content": [
              {
                "title": "1.与智能报账、影像、税务管理一体化，实现进项发票的归集、自动查验、自动查重、解析、存管、报销入账等全流程过程管理；"
              },
              {
                "title": "2.对增值税发票进行查验，票据自动转存影像文件，用于报销审核及电子档案存储；依据多种业务报账场景，对已采集的发票可进行转让；"
              }
            ]
          },
          {
            "img1": require("@/assets/images/industry/0505icon2.png"),
            "img2": require("@/assets/images/industry/0505icon1.png"),
            "title": "账务、报表一体化",
            "content": [
              {
                "title": "1.通过财务共享全自动生成凭证，实现智能记账；"
              },
              {
                "title": "2.通过财务共享报账业务及内部交易等的智能化、规范化，达到报表实时化。"
              },
              {
                "title": "3.以合同信息为基础，通过往来客商账龄、资金流动性等分析，加强过程管控。"
              },
              {
                "title": "4.定期发布关键指标、重点事项图表监控，并将抽象数据转换为管理报告，为项目管理提供决策依据。"
              }
            ]
          },
        ],
      ],
      moreindustryData: [
        [
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "机械制造"
          },
          {
            "img": require("@/assets/images/industry/moreindustry2.png"),
            "title": "高科技"
          },
          {
            "img": require("@/assets/images/industry/moreindustry3.png"),
            "title": "汽车"
          },
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "航空与国防"
          },
          {
            "img": require("@/assets/images/industry/moreindustry2.png"),
            "title": "水泥"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "建筑施工"
          },
          {
            "img": require("@/assets/images/industry/moreindustry2.png"),
            "title": "房地产"
          },
          {
            "img": require("@/assets/images/industry/moreindustry3.png"),
            "title": "物业管理"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "旅游"
          },
          {
            "img": require("@/assets/images/industry/moreindustry2.png"),
            "title": "零售"
          },
          {
            "img": require("@/assets/images/industry/moreindustry3.png"),
            "title": "餐饮"
          },
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "教育"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "医院"
          },
          {
            "img": require("@/assets/images/industry/moreindustry2.png"),
            "title": "政府及协会"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "石油天然气"
          },
          {
            "img": require("@/assets/images/industry/moreindustry2.png"),
            "title": "化工"
          },
          {
            "img": require("@/assets/images/industry/moreindustry3.png"),
            "title": "采矿"
          },
        ],
        [
          {
            "img": require("@/assets/images/industry/moreindustry1.png"),
            "title": "银行"
          },
          {
            "img": require("@/assets/images/industry/moreindustry2.png"),
            "title": "保险"
          },
          {
            "img": require("@/assets/images/industry/moreindustry3.png"),
            "title": "基金"
          }
        ]
      ],
      moreproductData: [
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/03-shuiwuguanliyun.png"),
            "title": "EEC-增值税管理云",
            "link": "/counter/3"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/05-zhihuiwnagyinyun.png"),
            "title": "EEC-智慧网银云",
            "link": "/counter/5"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/06-qmysgly.png"),
            "title": "EEC-全面预算云",
            "link": "/counter/6"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/04-ljmorebg1.png"),
            "title": "EEC-全球司库管理云",
            "link": "/counter/4"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          }
        ]
      ],
      // imgs: [
      //   {
      //     img1: require('@/assets/images/industry/1-2.png'),
      //     img2: require('@/assets/images/industry/1-1.png')
      //   }, {
      //     img1: require('@/assets/images/industry/2-2.png'),
      //     img2: require('@/assets/images/industry/2-1.png')
      //   }, {
      //     img1: require('@/assets/images/industry/3-2.png'),
      //     img2: require("@/assets/images/industry/3-1.png")
      //   }, {
      //     img1: require('@/assets/images/industry/4-2.png'),
      //     img2: require("@/assets/images/industry/4-1.png")
      //   }, {
      //     img1: require('@/assets/images/industry/5-2.png'),
      //     img2: require("@/assets/images/industry/5-1.png")
      //   }, {
      //     img1: require('@/assets/images/industry/6-2.png'),
      //     img2: require("@/assets/images/industry/6-1.png")
      //   }, {
      //     img1: require('@/assets/images/industry/7-2.png'),
      //     img2: require("@/assets/images/industry/7-1.png")
      //   }, {
      //     img1: require('@/assets/images/industry/8-2.png'),
      //     img2: require("@/assets/images/industry/8-1.png")
      //   }, {
      //     img1: require('@/assets/images/industry/9-2.png'),
      //     img2: require("@/assets/images/industry/9-1.png")
      //   }
      // ],
      bannerDate: {
        url: require("@/assets/images/industry/solutions1.png"),
        title: "制造行业智慧业财解决方案",
        content: "依托博信诚ECOP平台强大的整合服务能力，旨在解决企业财务管控、业务管控、数据管控等核心管理难题，助力企业打造产业、生态体系，促进也才深度融合，轻松实现数智化治理与管理转型。",
        btn: false,
        btns: true,
      },
    }
  },
  props: {
    logo: {
      type: String
    },
    showTopHeader: {
      type: Boolean,
      default: true
    },
    topbarStyle: {
      type: Number,
      default: 1
    },
    showThemeSwitcherButton: {
      type: Boolean,
      default: false
    },
    headerTransparency: {
      type: Boolean,
      default: false
    },
    headerClass: {
      type: String
    },
    navAlignment: {
      //控制nav 左右
      type: String,
      default: 'right'
    },
    buyButtonClass: {
      type: String,
      default: 'btn-default btn-small'
    },
    footerStyle: {
      type: Number,
      default: 1
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showCopyright: {
      type: Boolean,
      default: true
    },
    showNewsletter: {
      type: Boolean,
      default: true
    },
    showCta: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    console.log(this.$route);
    this.type = this.$route.params.type
    console.log('页面实时宽度', this.windowWidth);
    this.chagnerouter(this.type)
    this.titleData = this.titleDatas[this.type - 1]
    this.coreData = this.coreDatas[this.type - 1]
    this.titleData.map((val) => {
      val.img1 = require('@/assets/images/industry/' + val.img1)
      val.img2 = require('@/assets/images/industry/' + val.img2)
    })
    this.heighlightData = this.heighlightDatas[this.type - 1]
    this.titleChange(0)
  },
  methods: {
    chagnerouter(val) {
      console.log(val);
      this.$router.push({
        path: `/industry/${val}`
      })
      let ts = this
      if (val == 1) {
        ts.bannerDate = {
          url: require("@/assets/images/industry/solutions1.png"),
          title: "制造行业智慧业财解决方案",
          content: "依托博信诚ECOP平台强大的整合服务能力，旨在解决企业财务管控、业务管控、数据管控等核心管理难题，助力企业打造产业、生态体系，促进也才深度融合，轻松实现数智化治理与管理转型。",
          btn: false,
          btns: true,
        }
      } else if (val == 2) {
        ts.bannerDate = {
          url: require("@/assets/images/industry/solutions2.png"),
          title: "建筑与地产行业企业智慧业财解决方案",
          content: "依托博信诚ECOP平台强大的整合服务能力，旨在解决建筑地产企业项目管控、财务管控、业务管控、数据管控等核心管理难题，助力企业打造产业、生态体系，促进业财深度融合，轻松实现数智化治理与管理转型。",
          btn: false,
          btns: true,
        }
      } else if (val == 3) {
        ts.bannerDate = {
          url: require("@/assets/images/industry/solutions3.png"),
          title: "服务行业企业智慧财务解决方案",
          content: "依托博信诚ECOP平台强大的整合服务能力，旨在解决服务企业财务管控、业务管控、数据管控等核心管理难题，助力企业打造产业、生态体系，促进业财深度融合，轻松实现数智化治理与管理转型。",
          btn: false,
          btns: true,
        }
      } else if (val == 4) {
        ts.bannerDate = {
          url: require("@/assets/images/industry/solutions4.png"),
          title: "公共服务行业智慧财务解决方案",
          content: "依托博信诚ECOP平台强大的整合服务能力，旨在解决服务企业财务管控、业务管控、数据管控等核心管理难题，助力企业打造产业、生态体系，促进业财深度融合，轻松实现数智化治理与管理转型。",
          btn: false,
          btns: true,
        }
      } else if (val == 5) {
        ts.bannerDate = {
          url: require("@/assets/images/industry/solutions5.png"),
          title: "能源与矿业行业智慧财务解决方案",
          content: "依托博信诚ECOP平台强大的整合服务能力，旨在解决企业财务管控、业务管控、数据管控等核心管理难题，助力企业打造产业、生态体系，促进业财深度融合，轻松实现数智化治理与管理转型。",
          btn: false,
          btns: true,
        }
      } else if (val == 6) {
        ts.bannerDate = {
          url: require("@/assets/images/industry/solutions6.png"),
          title: "金融行业智慧业财解决方案",
          content: "依托博信诚ECOP平台强大的整合服务能力，旨在解决服务企业财务管控、业务管控、数据管控等核心管理难题，助力企业打造产业、生态体系，促进也才深度融合，轻松实现数智化治理与管理转型。",
          btn: false,
          btns: true,
        }
      }
    },
    toDetails(item){
      this.$router.push({
        path: item.link
      })
    },
    titleChange(val){
      console.log(val);
      for(let i = 0; i<this.titleData.length; i++){
        if(document.getElementById(i) && document.getElementById(i).getAttribute("class").indexOf('titleBox')!= -1){
          document.getElementById(i).classList.remove('titleBox')
        }
      }
      document.getElementById(val).classList.add('titleBox')
      console.log(document.getElementById(val));
    },
    slideChangeTransitionStartHandle(){
      let swiper = this.$refs.titleSwipers.swiper ? this.$refs.titleSwipers.swiper.realIndex : 0
      console.log(swiper);
      for(let i = 0; i<this.titleData[this.type - 1].length; i++){
        if(document.getElementById(i) && document.getElementById(i).getAttribute("class").indexOf('titleBox')!= -1){
          document.getElementById(i).classList.remove('titleBox')
        }
      }
      console.log(document.getElementById(swiper));
      document.getElementById(swiper).classList.add('titleBox')
    }
  },
  watch: {
    $route: {
      handler: function (to, from) {
		    location.reload();
        console.log(to.params);
        this.type = to.params.type
        this.chagnerouter(this.type)
        console.log(this.titleDatas[this.type - 1]);
        this.titleData = this.titleDatas[this.type - 1]
        this.titleData[this.type - 1].map((val) => {
          val.img1 = require('@/assets/images/industry/' + val.img1)
          val.img2 = require('@/assets/images/industry/' + val.img2)
        })
        this.heighlightData = this.heighlightDatas[this.type - 1]
      }
    },
    windowWidth(val) {
      let ts = this
      console.log('页面实时宽度', val, ts.windowWidth);
    }
  },
}
</script>
<style lang="scss" scoped>
.industryPage {
  .backimg {
    margin: 0 auto;
    max-width: 1920px;
    width: 100%;
  }

  .titles {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F6F7FA;

    .in_titles {
      display: flex;
      max-width: 1440px;
      height: 70px;
      width: 100%;
      padding: 0 70px;
      align-items: center;

      .in_titles_left {
        display: flex;
        width: 50%;
        align-items: center;

        .in_titles_left_img {
          height: 30%;
          margin-right: 10px;
        }
      }

      .in_titles_right {
        display: flex;
        flex: 1;
        justify-content: space-around;

        div {
          padding: 19px 0;
          cursor: pointer;
        }

        .changes {
          color: #186BB3;
          border-bottom: 4px solid #186BB3;
        }
      }
    }
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 5%;

    .title_in {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1440px;
    }

    .tab-block {
      div {
        padding-bottom: 1rem;
      }
    }
  }

  .titlecontents {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    .bg-block {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-position: center;
      background-repeat: no-repeat;

      .bg {
        position: absolute;
        background-image: url('../assets/images/industry/contentB.png');
        background-size: 100% 100%;
        background-attachment: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 1;
      }
    }

    .title_in {
      display: flex;
      margin-top: 5rem;
      flex-direction: column;
      align-items: center;
      z-index: 1;

      h3 {
        color: #Fff;
      }
    }

    .titlecontent {
      // margin-bottom: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;

      .titleSwiper {
        overflow: hidden;
        padding-bottom: 5rem;
        position: relative;

        .contentBox {
          position: relative;
          width: 100%;
          transition: all 2s;

          &:hover{
            .contentTitleimg {
              position: absolute;
              top: 0rem;
              left: 0rem;
              opacity: 1;
            }

            .contentTitleBox {
              padding: 0 3rem;
              overflow: hidden;
              height: 31rem;
              h5{
                color: #141c3c !important;
              }
              .contentimg1{
                display: none;
              }
              .contentimg{
                display: inline-block;
              }
              .contentTitle {
                height: 12rem;
                font-size: 16px;
                line-height: 1.625;
                opacity: 1;
                color: #141c3c;
              }
            }
          }
          .contentTitleimg {
            position: absolute;
            top: 0rem;
            left: 0rem;
            margin-top: 2.5%;
            width: 95%;
            height: 96%;
            opacity: 0;
            transition: all 1s;
          }

          .contentTitleimg1 {
            position: absolute;
            top: 0rem;
            left: 0rem;
            width: 98%;
            height: 100%;
          }
          .contentimg1 {
            height: 7rem;
            margin: 3rem 0;
            width: 10rem;
          }
          .contentTitleBox {
            margin-top: 1rem;
            padding: 1rem 3rem;
            height: 31rem;
            overflow: hidden;
            position: relative;
            text-align: center;
            transition: all 1s ease;

            .contentimg {
              height: 7rem;
              margin: 3rem 0;
              width: 10rem;
              display: none;
            }
            h5{
              color: #181818;
            }
            .contentTitle {
              height: 0;
              width: 90%;
              opacity: 0.1;
              color: #181818;
              transition: all 1s ease;
            }
          }
        }
        .titleBox {
          .contentTitleimg {
            position: absolute;
            top: 0rem;
            left: 0rem;
            opacity: 1;
          }

          .contentTitleBox {
            padding: 0 3rem;
            overflow: hidden;
            height: 31rem;
            h5{
              color: #141c3c !important;
            }
            .contentimg1{
              display: none;
            }
            .contentimg{
              display: inline-block;
            }
            .contentTitle {
              height: 12rem;
              font-size: 16px;
              line-height: 1.625;
              opacity: 1;
              color: #141c3c;
            }
          }
        }
      }

      .trades {
        display: flex;
        align-items: center;
        flex: 0.33;
        height: 60rem;
        overflow: hidden;

        .contentBox {
          position: relative;
          width: 100%;
          transition: all 2s;
          box-shadow: 0px 10px 30px 0px rgb(51 112 255 / 10%);

          .contentTitleimg {
            position: absolute;
            top: 0rem;
            left: 0rem;
            width: 95%;
            margin-top: 2.5%;
            height: 96%;
            opacity: 0;
            transition: all 1s;
          }

          .contentTitleimg1 {
            position: absolute;
            top: 0rem;
            left: 0rem;
            width: 98%;
            height: 100%;
          }

          .contentTitleBox {
            margin-top: 1rem;
            padding: 6rem 3rem;
            height: 31rem;
            overflow: hidden;
            position: relative;
            text-align: center;
            transition: all 1s ease;

            .contentimg1 {
              height: 7rem;
              margin: 3rem 0;
              width: 10rem;
            }
            .contentimg {
              height: 7rem;
              margin: 3rem 0;
              width: 10rem;
              display: none;
            }
            h5{
              color: #181818;
            }
            .contentTitle {
              height: 0;
              width: 90%;
              opacity: 0;
              color: #181818;
              transition: all 1s ease;
            }
          }
        }
        .titleBox {
          .contentTitleimg {
            position: absolute;
            top: 0rem;
            left: 0rem;
            opacity: 1;
          }

          .contentTitleBox {
            padding: 0 3rem;
            overflow: hidden;
            height: 31rem;
            h5{
              color: #141c3c !important;
            }
            .contentimg1{
              display: none;
            }
            .contentimg{
              display: inline-block;
            }
            .contentTitle {
              height: 12rem;
              font-size: 16px;
              line-height: 1.625;
              opacity: 1;
              color: #141c3c;
            }
          }
        }
      }
    }
  }

  .highlights {
    display: flex;
    flex-direction: column;
    background: #FAFAFA;
    padding-bottom: 5rem;

    .highlightsBox {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .highSwiper {
      margin-top: 5rem;

      .highSwiperBox {
        width: 100%;
        height: 100%;

        .mySwipe {
          margin-bottom: 5rem;

          .swiper-slide {
            .swiperBox {
              overflow: hidden;
              width: 100%;
              margin: 0;

              img {
                transition: transform 1s ease;
              }

              img:hover {
                transform: scale(1.3);
              }
            }
            background: #fff;
            div {
              height: 20rem;
              padding: 3rem;
              color: #141c3c;
            }
          }
        }
      }
    }
    .higBox{
      display: flex;
      justify-content: center;
      height: 40rem;
      div {
        .swiperBox {
          overflow: hidden;
          width: 100%;
          margin: 0;

          img {
            transition: transform 1s ease;
          }

          img:hover {
            transform: scale(1.3);
          }
        }
        background: #fff;
        div {
          height: 20rem;
          padding: 1rem;
          width: 27rem;
          color: #141c3c;
        }
      }
      background: #fff;
      div {
        height: 20rem;
        padding: 3rem;
        color: #141c3c;
      }
    }
  }

  .cores {
    position: relative;
    padding-bottom: 5rem;

    .bg-block {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-position: center;
      background-repeat: no-repeat;

      .bg {
        position: absolute;
        background-image: url('../assets/images/industry/136009556.png');
        background-size: 100% 100%;
        background-attachment: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 1;
      }
    }

    .tab-block {
      position: relative;
      z-index: 1;
    }

    .core {
      display: flex;
      position: relative;
      justify-content: space-between;
      z-index: 1;
      // margin-top: 1rem;

      .coreBoxs {
        width: 100%;
        height: 42rem;

        .mySwipe {
          .swiper-wrapper {
            align-items: center;

            .swiper-slide {
              width: 100%;
              height: auto;
              position: relative;
              display: flex;
              align-items: center;
              height: 100%;
              height: 25rem;
              transition: all 1s linear;
              overflow: hidden;
              &:hover{
                height: 38rem;
                .coreBox{
                  opacity: 0;
                }
                .coreBox2{
                  opacity: 1;
                  height: 38rem;
                  display: flex;
                  width: 100%;
                  .coreBoxTitle{
                    .coreBoxTitles_img{
                      opacity: 1;
                    }
                  }
                }
              }

              .coreBox {
                background-color: rgba(255,255,255,0.5);
                padding-top: 8rem;
                height: 25rem;
                width: 100%;
                overflow: hidden;
                transition: all 1s ease-out;
                .coreBoxTitle {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  p{
                    color: #141c3c;
                  }
                  .coreBoxTitle_img {
                    width: 15%;
                    margin-bottom: 10px;
                  }
                  p {
                    margin-bottom: 8px;
                  }
                }
                .coreBoxContent {
                  height: 0rem;
                  opacity: 0;
                }
              }
              .coreBox2{
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                display: none;
                background-image: linear-gradient(#2395C7, #092DA6);
                padding-top: 8rem;
                overflow: hidden;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                padding: 2rem;
                transition: all 1s linear;
                padding-top: 5rem;
                width: 100%;
                .coreBoxTitle {
                  display: flex;
                  align-items: center;

                  .coreBoxTitles_img {
                    width: 15%;
                    margin-bottom: 10px;
                    margin-right: 10px;
                    opacity: 0;
                    transition: all 1s ease;
                  }
                }
                .coreBoxContent {
                  height: 25rem;
                  p{
                    margin: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .mores {
    top: 0 !important;
    height: 40rem !important;

    .moreTitles {
      display: flex;
      justify-content: center;

      .text-center {
        padding-bottom: 2rem;
        color: #808080;
        margin: 3rem;
        margin-top: 0;
        cursor: pointer;
      }

      .active {
        border-bottom: 1rem solid #1558B3;
        color: #000;
      }
    }

    .more {
      height: 100%;
      .moreBoxs {
        .mySwipe {
          margin-bottom: 1rem;
          .swiper-wrapper {
            .swiper-slide {
              .moreBox {
                position: relative;
                transition: all 1s ease;
                overflow: hidden;
                &:hover {
                  .moreBoxImgs{
                    .moreBoxImg1{
                      transform: scale(1.1);
                    }
                    .moreBoxImg2 {
                      transform: scale(1.1);
                      opacity: 0.7;
                    }
                  }

                  .moreBoxContent {
                    top: 6rem;
                  }

                  .liaojieallborder {
                    opacity: 1 !important;
                  }
                }

                .moreBoxImgs{
                  .moreBoxImg1{
                    transition: all 1s linear;
                  }
                  .moreBoxImg2 {
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    transition: all 1s linear;
                  }
                  .imgs{
                    height: 20rem;
                    margin-bottom: 1rem;
                  }
                }

                .moreBoxContent {
                  position: absolute;
                  top: 10rem;
                  left: 0rem;
                  display: flex;
                  padding: 0 5rem;
                  width: 100%;
                  flex-direction: column;
                  align-items: center;
                  transition: all 1s ease;

                  h5 {
                    color: white;
                    text-align: center;
                  }

                  button {
                    margin: 0;
                  }

                  .liaojieallborder {
                    opacity: 0;
                    transition: all 1s ease;
                  }
                }
              }
            }
          }
        }
      }
    }

    .morer {
      margin-top: -400px;
      .moreBoxes {
        .mySwipe {
          margin-bottom: 1rem;
          .swiper-wrapper {
            .swiper-slide {
              .moreBox {
                position: relative;
                transition: all 1s ease;
                overflow: hidden;
                &:hover {
                  .moreBoxImgs{
                    .moreBoxImg1{
                      transform: scale(1.1);
                    }
                    .moreBoxImg2 {
                      transform: scale(1.1);
                      opacity: 0.7;
                    }
                  }


                  .moreBoxContent {
                    top: 5rem;
                  }

                  .liaojieallborder {
                    opacity: 1 !important;
                  }
                }
                // .moreBoxImg1{
                //   height: 21rem;
                //   border-radius: 0.5rem;
                //   margin-left: 2rem;
                // }
                .moreBoxImgs{
                  .moreBoxImg1{
                    transition: all 1s linear;
                  }
                  .moreBoxImg2 {
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    transition: all 1s linear;
                  }
                  .imgs{
                    height: 20rem;
                    margin-bottom: 1rem;
                  }
                }

                .moreBoxContent {
                  position: absolute;
                  top: 10rem;
                  left: 0rem;
                  display: flex;
                  padding: 0 5rem;
                  flex-direction: column;
                  align-items: center;
                  transition: all 1s ease;
                  width: 100%;

                  h5 {
                    color: white;
                    text-align: center;
                  }

                  button {
                    margin: 0;
                  }

                  .liaojieallborder {
                    opacity: 0;
                    transition: all 1s ease;
                  }
                }
              }
            }
          }
        }
      }
    }

  }

  .btnBox {
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('../assets/images/industry/drawing.png') no-repeat;

    .inBtn {
      display: flex;
      padding: 0 70px;
      justify-content: space-around;
      height: 374px;

      .inBtnBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 60px;
        background-color: rgba(255, 255, 255, 0);
        border: 1px solid rgba(255, 255, 255, 0.3);

        .inBox_text {
          height: 70%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .inBox_text_img {
            color: #FFF;
          }

          .inBox_text_title {
            color: #fff;
            margin-top: 10px;
          }
        }

        .inBox_content {
          flex: 1;
          color: #fff;
          margin-top: -40px;
        }

        &:hover {
          background-color: rgba(255, 255, 255, 0.3);

          .inBox_text_img {
            transform: rotateY(360deg);
            transition: transform 3s ease;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.coreBoxs {
  .mySwipe {
    .swiper-wrapper {
      align-items: center;
    }
  }
}

.swiper-pagination-clickable {
  left: 45%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 10%;

  .swiper-pagination-bullet-active {
    width: 1.5rem !important;
    height: 1.5rem !important;
    border-radius: 50%;
    border: 2px solid #2267B9;
    background-color: #fff !important;
  }

  .swiper-pagination-bullet {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: #C5C5C5;
  }
}

.ind {
  z-index: 1;
}
.mgb1{
  margin-bottom: 1rem;
}
</style>